import { useEffect as t } from "react";
const d = (o) => {
  const { isDisabled: e } = o;
  t(() => (e ? (document.documentElement.style.overflow = "hidden", document.body.style.overflow = "hidden") : (document.documentElement.style.overflow = "auto", document.body.style.overflow = "auto"), () => {
    document.documentElement.style.overflow = "auto", document.body.style.overflow = "auto";
  }), [e]);
};
export {
  d as useDisableScroll
};
